{
  "id": "campaign-131",
  "name": "Final Park",
  "seed": "campaign:131",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "r.....QQQQ.....r",
    "...:....~...:...",
    "..~:...~....:...",
    "..~::::::::::...",
    "..a.a....x.a.a..",
    "................",
    "..q..#,......q..",
    ".a.a.,.,#...a.a.",
    "::::::::::::::::",
    "~..a..a..a..a...",
    ".~...a....a.....",
    "....q.....,q,...",
    "......#....,....",
    "...::::::::::...",
    "..a:a......a:a..",
    "...:........:...",
    "S.....QQQQ......"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 14,
      "y": 10
    },
    {
      "kind": "rabbit",
      "x": 4,
      "y": 8
    },
    {
      "kind": "squirrel",
      "x": 13,
      "y": 0
    },
    {
      "kind": "squirrel",
      "x": 10,
      "y": 13
    },
    {
      "kind": "rabbit",
      "x": 5,
      "y": 13
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 2,
      "y": 6
    },
    {
      "kind": "gas",
      "x": 9,
      "y": 7
    },
    {
      "kind": "gas",
      "x": 0,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 14
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "balls": {
    "first": 18,
    "every": 13
  },
  "generatorVersion": 3,
  "level": 131,
  "biome": "stadium",
  "par": {
    "reel": 8943,
    "push": 7985,
    "selfPropelled": 7524,
    "tractor": 6290,
    "zeroTurn": 5362,
    "fairway": 3242
  },
  "goldTime": {
    "reel": 8943,
    "push": 7985,
    "selfPropelled": 7416,
    "tractor": 6130,
    "zeroTurn": 5233,
    "fairway": 3225
  },
  "routeTries": {
    "par": {
      "reel": 11,
      "push": 22,
      "selfPropelled": 4,
      "tractor": 24,
      "zeroTurn": 3,
      "fairway": 13
    },
    "gold": {
      "reel": 11,
      "push": 22,
      "selfPropelled": 48,
      "tractor": 26,
      "zeroTurn": 31,
      "fairway": 38
    }
  }
}
